"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShippingRules = exports.getShippingRule = exports.ShippingRules = void 0;
const typings_1 = require("../typings");
const fixed_price_1 = require("./fixed-price");
const per_unit_price_1 = require("./per-unit-price");
const unit_price_1 = require("./unit-price");
exports.ShippingRules = new Map()
    .set(typings_1.ShippingRuleType.FIXED_PRICE, fixed_price_1.FixedPriceShippingRule)
    .set(typings_1.ShippingRuleType.PER_UNIT_PRICE, per_unit_price_1.PerUnitPriceShippingRule)
    .set(typings_1.ShippingRuleType.UNIT_PRICE, unit_price_1.UnitPriceShippingRule);
/**
 * Get shipping rule with shipping rule's properties
 * @param shippingRuleProperties
 */
function getShippingRule(shippingRuleProperties) {
    const ShippingRule = exports.ShippingRules.get(shippingRuleProperties.type);
    if (!ShippingRule) {
        return undefined;
    }
    return new ShippingRule(shippingRuleProperties);
}
exports.getShippingRule = getShippingRule;
/**
 * Get shipping rules with shipping rules properties
 * @param shippingRulesProperties
 */
function getShippingRules(shippingRulesProperties) {
    return shippingRulesProperties.map(getShippingRule).filter(Boolean);
}
exports.getShippingRules = getShippingRules;
//# sourceMappingURL=index.js.map